var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons---LMS,-CTIMS",
    transform: "translate(-255.000000, -716.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(218.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_learning",
    transform: "translate(37.000000, 560.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5211479,3.26119207 L1.61014618,8.12173845 C1.12529784,8.38620118 0.946640004,8.99363782 1.21110273,9.47848615 C1.3031052,9.64715733 1.4417504,9.78575397 1.61045381,9.87769732 L4,11.18 L4,11.18 L4,16.5865022 C4,16.9523747 4.19980941,17.2890388 4.52097216,17.4643019 L10.5209722,20.7385877 C10.8195418,20.9015214 11.1804582,20.9015214 11.4790278,20.7385877 L17.4790278,17.4643019 C17.8001906,17.2890388 18,16.9523747 18,16.5865022 L18,11.18 L18,11.18 L20,10.09 L20,16 C20,16.5522847 20.4477153,17 21,17 C21.5522847,17 22,16.5522847 22,16 L22,9.5936331 C22,9.22768888 21.8001129,8.8909707 21.4788521,8.71573753 L11.4788521,3.26119207 C11.1803746,3.09838617 10.8196254,3.09838617 10.5211479,3.26119207 Z M17.82,9 L11,12.72 L4.18,9 L11,5.28 L17.82,9 Z M16,15.99 L11,18.72 L6,15.99 L6,12.27 L10.5207789,14.7383453 C10.8194499,14.9014196 11.1805501,14.9014196 11.4792211,14.7383453 L16,12.27 L16,12.27 L16,15.99 Z",
    id: "Shape",
    fill: "#616674"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLms);
export default __webpack_public_path__ + "static/media/lms.fe6af05d9d7a83b3e04c18c1911ace85.svg";
export { ForwardRef as ReactComponent };